import React from "react";
import styles from "./FinanceDetailsCard.module.scss";
import { Col, Row } from "antd";
import { getFinanceDetails } from "./constants";

interface FinanceDetailsCardProps {
  revenue: number;
  cogs: number;
  grossProfit: number;
  terms: string;
}

const FinanceDetailsCard = ({
  revenue,
  cogs,
  grossProfit,
  terms,
}: FinanceDetailsCardProps) => {
  return (
    <div className={styles.financeCard}>
      <Row gutter={[12, 12]}>
        {getFinanceDetails({
          revenue: revenue,
          grossProfit: grossProfit,
          cogs: cogs,
          terms: terms,
        })?.map((item) => (
          <Col span={12}>
            <div className={styles.itemWrapper}>
              <div className={styles.valueText}>{item.value}</div>
              <div className={styles.labelText}>{item.label}</div>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default FinanceDetailsCard;
